import {CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {RcfaSummaryContainer} from '@widgets/downtime-analytics'
import moment from 'moment'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  plantId: string
  linkPath?: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const RcfaContainer = ({plantId, linkPath, cardBoxSx, placeholderWrapperSx}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)
  const startOfToday = moment.utc().tz(timezone).startOf('day')
  const thirtyDaysAgo = startOfToday.clone().subtract(30, 'day')
  const endOfToday = startOfToday.clone().endOf('day')
  const timeRange = {
    startDate: thirtyDaysAgo.toISOString(),
    endDate: endOfToday.toISOString()
  }

  const content = (
    <RcfaSummaryContainer
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
      plantId={plantId}
      from={timeRange.startDate}
      to={timeRange.endDate}
      timeRangeLabel={t('label.last30days')}
    />
  )

  if (linkPath) {
    return (
      <CardLinkWrapper href={linkPath} data-test-id="rcfa-summary-card-link-to-maintain">
        {content}
      </CardLinkWrapper>
    )
  }

  return content
}
